import React from 'react';
import styles from './InsufficientPointsModal.module.css';

interface InsufficientPointsModalProps {
  isOpen: boolean;
  onClose: () => void;
  featureName: string;
  pointsNeeded: number;
  currentPoints: number;
  onUpgrade?: () => void;
}

const InsufficientPointsModal: React.FC<InsufficientPointsModalProps> = ({
  isOpen,
  onClose,
  featureName,
  pointsNeeded,
  currentPoints,
  onUpgrade,
}) => {
  if (!isOpen) return null;

  const shortfall = pointsNeeded - currentPoints;

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.header}>
          <div className={styles.iconContainer}>
            <div className={styles.warningIcon}>⚠️</div>
          </div>
          <h2 className={styles.title}>Insufficient Points</h2>
          <button className={styles.closeButton} onClick={onClose}>
            ✕
          </button>
        </div>

        <div className={styles.content}>
          <div className={styles.message}>
            <p className={styles.primaryMessage}>
              You don't have enough points to use <strong>{featureName}</strong>.
            </p>
            
            <div className={styles.breakdown}>
              <div className={styles.breakdownItem}>
                <span className={styles.label}>Points needed:</span>
                <span className={styles.value}>{pointsNeeded.toLocaleString()}</span>
              </div>
              <div className={styles.breakdownItem}>
                <span className={styles.label}>Current balance:</span>
                <span className={styles.value}>{currentPoints.toLocaleString()}</span>
              </div>
              <div className={styles.separator}></div>
              <div className={styles.breakdownItem}>
                <span className={styles.label}>Additional needed:</span>
                <span className={`${styles.value} ${styles.shortage}`}>
                  {shortfall.toLocaleString()}
                </span>
              </div>
            </div>
          </div>

          <div className={styles.suggestions}>
            <h3 className={styles.suggestionsTitle}>What you can do:</h3>
            <ul className={styles.suggestionsList}>
              <li>
                <span className={styles.suggestionIcon}>💎</span>
                <span>Upgrade to a higher plan with more points</span>
              </li>
              <li>
                <span className={styles.suggestionIcon}>📅</span>
                <span>Wait for your monthly points to reset</span>
              </li>
              <li>
                <span className={styles.suggestionIcon}>🎯</span>
                <span>Try a feature that costs fewer points</span>
              </li>
            </ul>
          </div>
        </div>

        <div className={styles.actions}>
          <button className={styles.secondaryButton} onClick={onClose}>
            Maybe Later
          </button>
          
          <button 
            className={styles.primaryButton}
            onClick={onUpgrade || (() => window.location.href = '/pricing')}
          >
            <span className={styles.upgradeIcon}>⚡</span>
            View Upgrade Options
          </button>
        </div>
      </div>
    </div>
  );
};

export default InsufficientPointsModal;